/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import {
  Box,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
} from '@mui/material';
import { useEffect, useState } from 'react';

import { apiUrl } from '../../utilities/apiUrl';
import { useOutletContext } from 'react-router-dom';

import {
  PersonalInformation,
  EducationalBackground,
  CivilService,
  EmployeeHistoryComponent,
  EmployeeTrainingsComponent,
  Addresses,
  VoluntaryWorksComponent,
  WorkExpComponent,
  FamilyBackground,
} from '../index';

export const EmployeeDetails = (props) => {
  const [empId] = useOutletContext();
  const [empWorkExp, setEmpWorkExp] = useState([]);
  const [empVolWork, setVolWork] = useState([]);
  const [emptrn, setEmpTrn] = useState([]);
  const [empRelations, setEmpRelations] = useState([]);
  const [empAddresses, setEmpAddresses] = useState([]);
  const [empEducation, setEmpEducation] = useState([]);
  const [empCivService, setEmpCivService] = useState([]);
  const [empHistory, setEmpHistory] = useState([]);

  useEffect(() => {
    //Create function calls
    const fetchEmployeeRelations = async () => {
      try {
        const response = await fetch(apiUrl(`/eis/emprelations/${empId}`), {
          method: 'GET',
          credentials: 'include',
        });

        const result = await response.json();

        if (result.success) {
          setEmpRelations(result.data);
        } else {
          console.warn('API call succeeded but returned unsuccessful status.');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const fetchEmployeeAddresses = async () => {
      try {
        const response = await fetch(apiUrl(`/eis/empaddress/${empId}`), {
          method: 'GET',
          credentials: 'include',
        });

        const result = await response.json();

        if (result.success) {
          setEmpAddresses(result.data);
        } else {
          console.warn('API call succeeded but returned unsuccessful status.');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const fetchEmpEducation = async () => {
      try {
        const response = await fetch(apiUrl(`/eis/empeducation/${empId}`), {
          method: 'GET',
          credentials: 'include',
        });

        const result = await response.json();

        if (result.success) {
          setEmpEducation(result.data);
        } else {
          console.warn('API call succeeded but returned unsuccessful status.');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const fetchEmpCivService = async () => {
      try {
        const response = await fetch(apiUrl(`/eis/empcivservice/${empId}`), {
          method: 'GET',
          credentials: 'include',
        });

        const result = await response.json();

        if (result.success) {
          setEmpCivService(result.data);
        } else {
          console.warn('API call succeeded but returned unsuccessful status.');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const fetchWorkExpData = async () => {
      try {
        const response = await fetch(apiUrl(`/eis/empworkexp/${empId}`), {
          method: 'GET',
          credentials: 'include',
        });
        const result = await response.json();
        if (result.success) {
          setEmpWorkExp(result.data);
        } else {
          console.warn('API call succeeded but returned unsuccessful status.');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const fetchVoluntaryWorks = async () => {
      try {
        const response = await fetch(apiUrl(`/eis/empcivicwork/${empId}`), {
          method: 'GET',
          credentials: 'include',
        });
        const result = await response.json();
        if (result.success) {
          setVolWork(result.data);
        } else {
          console.warn('API call succeeded but returned unsuccessful status.');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const fetchTrainingPrograms = async () => {
      try {
        const response = await fetch(apiUrl(`/eis/emptraining/${empId}`), {
          method: 'GET',
          credentials: 'include',
        });
        const result = await response.json();
        if (result.success) {
          setEmpTrn(result.data);
        } else {
          console.warn('API call succeeded but returned unsuccessful status.');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const fetchHistory = async () => {
      try {
        const response = await fetch(apiUrl(`/eis/emphistory/${empId}`), {
          method: 'GET',
          credentials: 'include',
        });
        const result = await response.json();
        if (result.success) {
          setEmpHistory(result.data);
        } else {
          console.warn('API call succeeded but returned unsuccessful status.');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    //Call function Calls
    if (props.currentTab === 'familyBackground') {
      fetchEmployeeRelations();
    }

    if (props.currentTab === 'addresses') {
      fetchEmployeeAddresses();
    }

    if (props.currentTab === 'educBackground') {
      fetchEmpEducation();
    }

    if (props.currentTab === 'civService') {
      fetchEmpCivService();
    }
    if (props.currentTab === 'workExp') {
      fetchWorkExpData();
    }
    if (props.currentTab === 'volWork') {
      fetchVoluntaryWorks();
    }
    if (props.currentTab === 'trainingProgs') {
      fetchTrainingPrograms();
    }
    if (props.currentTab === 'history') {
      fetchHistory();
    }
  }, [props.currentTab]);

  return (
    <>
      {props.currentTab === 'personalInfo' && (
        <PersonalInformation empData={props.empData} />
      )}

      {props.currentTab === 'addresses' && (
        <Addresses empAddresses={empAddresses} />
      )}

      {props.currentTab === 'familyBackground' && (
        <FamilyBackground empRelations={empRelations} />
      )}

      {props.currentTab === 'educBackground' && (
        <EducationalBackground empEducation={empEducation} />
      )}

      {props.currentTab === 'civService' && (
        <CivilService empCivService={empCivService} />
      )}

      {props.currentTab === 'workExp' && (
        <WorkExpComponent empWorkExp={empWorkExp}> </WorkExpComponent>
      )}

      {props.currentTab === 'volWork' && (
        <VoluntaryWorksComponent
          empVolWork={empVolWork}
        ></VoluntaryWorksComponent>
      )}

      {props.currentTab === 'trainingProgs' && (
        <EmployeeTrainingsComponent emptrn={emptrn}>
          {' '}
        </EmployeeTrainingsComponent>
      )}

      {props.currentTab === 'history' && (
        <EmployeeHistoryComponent empHistory={empHistory}>
          {' '}
        </EmployeeHistoryComponent>
      )}
    </>
  );
};
